import type { Me } from "./api";

/**
 * The app-bar chip that says this is not production. Production shows none: it serves live data
 * with the local sign-in off (the image and the task definition set KEYPORTAL_DEV_AUTH=false).
 */
export function modeChip(me: Pick<Me, "readOnly" | "devAuth">): { label: string; title: string; snapshot: boolean } | null {
  if (me.readOnly) return { label: "Snapshot · read-only", title: "Production snapshot, read-only", snapshot: true };
  if (me.devAuth) return { label: "Local", title: "Local LiteLLM stack", snapshot: false };
  return null;
}
